/* unplugin-vue-components disabled */import { render } from "./DeviceOaid.vue?vue&type=template&id=74dd3b3e&scoped=true"
import script from "./DeviceOaid.vue?vue&type=script&lang=js"
export * from "./DeviceOaid.vue?vue&type=script&lang=js"

import "./DeviceOaid.vue?vue&type=style&index=0&id=74dd3b3e&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dd3b3e"]])

export default __exports__